import { EMPTY_STRING } from '../../constants/common'
import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../Building'

export const CONTRACT_FORM_FIELD_NAME_INHABITANT = 'inhabitant'

export const CONTRACT_FORM_FIELD_NAME_BUILDING = 'building'

export const CONTRACT_FORM_FIELD_NAME_FLAT = 'flat'

export const CONTRACT_FORM_FIELD_NAME_CONTRACT_ID = 'contract_id'

export const CONTRACT_FORM_FIELD_NAME_PURCHASE_CONTRACT_NUMBER =
  'purchase_contract_number'

export const CONTRACT_FORM_FIELD_NAME_START_DATE = 'start_date'

export const CONTRACT_FORM_FIELD_NAME_END_DATE = 'end_date'

export const CONTRACT_FORM_FIELD_NAME_DURATION = 'duration'

export const CONTRACT_FORM_CONTRACT_ID_MAX_LENGTH = 255

export const CONTRACT_FORM_DURATION_MIN = 1

export const CONTRACT_FORM_DURATION_MAX = 9999

export const CONTRACT_DEFAULT_EVICTION_DELAY_DAYS = 0

export const CONTRACT_FORM_BUILDING_OPTIONS_API_PARAMS = {
  ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
  archived: false,
}

export const CONTRACT_FORM_DISABLED_FIELD_PROPS = { disabled: true }

export const CONTRACT_FORM_INITIAL_VALUES = {
  [CONTRACT_FORM_FIELD_NAME_BUILDING]: null,
  [CONTRACT_FORM_FIELD_NAME_CONTRACT_ID]: EMPTY_STRING,
  [CONTRACT_FORM_FIELD_NAME_DURATION]: EMPTY_STRING,
  [CONTRACT_FORM_FIELD_NAME_END_DATE]: null,
  [CONTRACT_FORM_FIELD_NAME_FLAT]: null,
  [CONTRACT_FORM_FIELD_NAME_INHABITANT]: null,
  [CONTRACT_FORM_FIELD_NAME_PURCHASE_CONTRACT_NUMBER]: EMPTY_STRING,
  [CONTRACT_FORM_FIELD_NAME_START_DATE]: null,
}
